import { createFileRoute, Link } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import { WBSButton } from '@/common/WBSButton';
import FollowUpPartnerDirectoryTable from '@/tables/FollowUpPartnerDirectoryTable';
import { PageContainer } from '~/styles/boardStyles';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

export const Route = createFileRoute('/_app/follow-up-partners/')({
  component: AllPartnersScreen,
});

/**
 * The coordinator's All Partners tab: a heading, an Add Partner button and the
 * table. One title, where legacy also showed the group name, since the
 * follow-up groups are gone.
 */
function AllPartnersScreen(): ReactElement {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <GroupHeaderWrapper>
        <TitleWithQuestion
          title={t('wbs.all-partners')}
          placement="follow_up_partners"
        />
        {/* A link, as legacy's button is, so Playwright sees the link role;
           `data-testid` pins it regardless. */}
        <WBSButton
          as={Link}
          to="/follow-up-partners/new"
          wide
          data-testid="add-partner"
        >
          {t('actions.add-partner')}
        </WBSButton>
      </GroupHeaderWrapper>
      <FollowUpPartnerDirectoryTable />
    </PageContainer>
  );
}
